import get from 'lodash/get';
import pickBy from 'lodash/pickBy';
import { convertToHTML } from 'draft-convert';
import { convertFromRaw } from 'draft-js';

export const getEnabledCriteria = (crits, customCrits) => {
  return pickBy(crits, (crit, key) => {
    const enabled = get(customCrits, [key, 'enabled'], true);
    return enabled === true;
  });
};

export const getHtmlFromDraftState = (draftState) => {
  if (draftState === null) {
    return null;
  }

  const raw = convertFromRaw(draftState);
  const plain = raw.getPlainText();
  if (plain.length === 0) {
    return null;
  }

  return convertToHTML(raw);
};

export const getCompetitorsUrls = (competitors) => {
  if (!competitors) {
    return [];
  }

  return competitors.map(competitor => competitor.url);
};
